import ReactInput from "../../../components/Inputs/ReactInput";
import InputLabel from "../../../components/Inputs/InputLable";
import { isObject, useFormikContext } from "formik";
import ReactSelect from "../../../components/Inputs/ReactSelect";
import ReactMultiSelect from "../../../components/Inputs/ReactMultiSelect";
import { useContext } from "react";
import { UserContext } from "../../../Context/UserContextAPI";

const SettingsForm = () => {
  const { values, setFieldValue } = useFormikContext();
  const { accessPerm } = useContext(UserContext);
  const daysOfWeekData = [
    { id: "0", value: "Sunday", label: "Sunday" },
    { id: "1", value: "Monday", label: "Monday" },
    { id: "2", value: "Tuesday", label: "Tuesday" },
    { id: "3", value: "Wednesday", label: "Wednesday" },
    { id: "4", value: "Thursday", label: "Thursday" },
    { id: "5", value: "Friday", label: "Friday" },
    { id: "6", value: "Saturday", label: "Saturday" },
  ];

  return (
    <div className="border p-4 rounded">
      <div className="card-title d-flex align-items-center">
        <h5 className="mb-0">System Settings</h5>
      </div>
      <hr />
      <div className="row mb-3">
        <InputLabel
          className="col-sm-3 col-form-label "
          title="Website Name"
          required
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="website_name"
            placeholder="Website Name"
            required
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel className="col-sm-3 col-form-label " title="GCC Code" />
        <div className="col-sm-9">
          <ReactInput type="text" name="gcc_code" placeholder="GCC Code" />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="website_url"
          title="Website URL"
          required
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            id="website_url"
            type="text"
            name="website_url"
            placeholder="Website URL"
            required
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="qrcode_url"
          title="QR Code URL"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            id="qrcode_url"
            type="text"
            name="qrcode_url"
            placeholder="QR Code URL"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="tag_line"
          className="col-sm-3 col-form-label"
          title="Tag Line"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="tag_line"
            id="tag_line"
            placeholder="Tag Line"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="short_name"
          title="Short Name (Optional)"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="short_name"
            id="short_name"
            placeholder="Short Name (Optional)"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="address"
          title="Address"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="address"
            id="address"
            rows={3}
            placeholder="Address"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="contact_numbers"
          title="Contact Numbers"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="mobile"
            id="mobile"
            rows={2}
            placeholder="Contact Numbers"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="header_image"
          title="Header"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="header_image"
            // onChange={(e) => {
            //   previewHeaderImage(e);
            // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <label htmlFor="inputHeader" className="col-sm-3 col-form-label">
          Header Preview
        </label>
        <div className="col-sm-9">
          {isObject(values?.header_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.header_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.header_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="footer_image"
          title="Footer"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="footer_image"
            // onChange={(e) => {
            //   previewFooterImage(e);
            // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <label htmlFor="inputPhoneNo2" className="col-sm-3 col-form-label">
          Footer Preview
        </label>
        <div className="col-sm-9">
          {isObject(values?.footer_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.footer_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.footer_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="background_image"
          title="Report Background Image"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="background_image"
            // onChange={(e) => {
            //   previewBackgroundImage(e);
            // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <label htmlFor="inputPhoneNo2" className="col-sm-3 col-form-label">
          Background Preview
        </label>
        <div className="col-sm-9">
          {isObject(values?.background_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.background_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.background_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="logo_image"
          title="Logo"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="logo_image"
            // onChange={(e) => {
            //   previewLogoImage(e);
            // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="inputPhoneNo2"
          title="Logo Preview"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          {isObject(values?.logo_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.logo_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.logo_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="fav_image"
          title="Favicon"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="fav_image"
            // onChange={(e) => {
            //   previewFaviconImage(e);
            // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="inputPhoneNo2"
          title="Favicon Preview"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          {isObject(values?.fav_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.fav_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.fav_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="mb-3 row">
        <InputLabel
          htmlFor="vat_type"
          title="VAT Type"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <select
            value={values?.vat_type}
            onChange={(e) => setFieldValue("vat_type", e.target.value)}
            className="single-select form-select"
          >
            <option value={1}>Included</option>
            <option value={2}>Excluded</option>
          </select>
        </div>
      </div>
      <div className="mb-3 row">
        <InputLabel
          htmlFor="inputDaysOfWeek"
          className="col-sm-3 col-form-label d-flex justify-content-start"
          title="Days of Week"
        />
        <div className="col-sm-9">
          <ReactMultiSelect
            name="days_of_week"
            isMulti
            value={daysOfWeekData.filter((item) =>
              values?.days_of_week?.includes(item.id),
            )}
            onChange={(e) => {
              const daysOfWeekString = e.map((item) => item.id).join(",");
              setFieldValue("days_of_week", daysOfWeekString);
            }}
            options={daysOfWeekData}
            valueName="id"
            labelName="value"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="point"
          title="1 Point ="
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput type="number" name="point" placeholder="1 Point =" />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="introducer_label"
          title="Introducer Label"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="introducer_label"
            placeholder="Introducer Label"
          />
        </div>
      </div>

      {/* package and introducer hide if one length */}

      <div className="row mb-3">
        <InputLabel
          htmlFor="agency_package_hide"
          title={"Agency/Package Hide"}
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <select
            className="form-select"
            name="agency_package_hide"
            value={values?.agency_package_hide}
            onChange={(e) =>
              setFieldValue("agency_package_hide", e.target.value)
            }
          >
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
      </div>

      {/* reg prefix type  */}

      <div className="row mb-3">
        <InputLabel
          htmlFor="reg_prefix_type"
          title={"Reg Prefix Type"}
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <select
            className="form-select"
            name="reg_prefix_type"
            value={values?.reg_prefix_type}
            onChange={(e) => setFieldValue("reg_prefix_type", e.target.value)}
          >
            <option value={1}>Static Code</option>
            <option value={2}>Country Code</option>
          </select>
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="reg_prefix"
          title="Reg. Prefix"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput type="text" name="reg_prefix" placeholder="Reg. Prefix" />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="reg_no"
          title="Reg. No."
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-2">
          <select
            className="form-select medical-form-select py-2 fw-bold"
            name="reset_reg_sequence"
            aria-label="Default select example"
            style={{ maxWidth: "160px" }}
            value={values?.reset_reg_sequence}
            onChange={(e) =>
              setFieldValue("reset_reg_sequence", e.target.value)
            }
          >
            <option value={1}>Not Reset Registration No.</option>
            <option value={2}>Reset in Monthly</option>
            <option value={3}>Reset in Yearly</option>
          </select>
        </div>
        <div className="col-sm-2">
          <select
            className="form-select medical-form-select py-2 fw-bold"
            name="year"
            aria-label="Default select example"
            style={{ maxWidth: "160px" }}
            value={values?.year}
            onChange={(e) => setFieldValue("year", e.target.value)}
          >
            <option value={""}>Select Year</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-sm-2">
          <select
            className="form-select medical-form-select py-2 fw-bold"
            name="month"
            aria-label="Default select example"
            style={{ maxWidth: "160px" }}
            value={values?.month}
            onChange={(e) => setFieldValue("month", e.target.value)}
          >
            <option value={""}>Select Month</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-sm-2">
          <ReactInput
            style={{ maxWidth: "160px" }}
            type="text"
            name="starting_digit"
            placeholder="Starting Digit"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="package_in_medical_form"
          title="Package in Medical Form"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Show" },
              { id: 2, value: "Hide" },
            ]}
            value={values?.package_in_medical_form}
            onChange={(e) => setFieldValue("package_in_medical_form", e)}
            valueName="id"
            labelName="value"
            placeholder="Package in Medical Form"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="barcode_content"
          title="BarCode Content In Medical Reports"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Serial No" },
              { id: 2, value: "Reg. No." },
              { id: 3, value: "Unique ID" },
            ]}
            value={values?.barcode_content}
            onChange={(e) => setFieldValue("barcode_content", e)}
            valueName="id"
            labelName="value"
            placeholder="BarCode Content"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="next_prev_button"
          title="Next Prev Button"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Show" },
              { id: 2, value: "Hide" },
            ]}
            value={values?.next_prev_button}
            onChange={(e) => setFieldValue("next_prev_button", e)}
            valueName="id"
            labelName="value"
            placeholder="Next Prev Button"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="reg_img_fp_cn"
          title="Reg Img - FP - CN "
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Required" },
              { id: 2, value: "Optional" },
            ]}
            value={values?.reg_img_fp_cn}
            onChange={(e) => setFieldValue("reg_img_fp_cn", e)}
            valueName="id"
            labelName="value"
            placeholder="Reg Img - FP - CN"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="reg_submit_button"
          title="Reg Submit Button"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Only Save" },
              { id: 2, value: "Save & 2 Page Print" },
              { id: 3, value: "Save & 3 Page Print" },
            ]}
            value={values?.reg_submit_button}
            onChange={(e) => setFieldValue("reg_submit_button", e)}
            valueName="id"
            labelName="value"
            placeholder="Reg Submit Button"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="collection_barcode_printing"
          title="Collection Barcode Printing"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Auto" },
              { id: 2, value: "Manual" },
            ]}
            value={values?.collection_barcode_printing}
            onChange={(e) => setFieldValue("collection_barcode_printing", e)}
            valueName="id"
            labelName="value"
            placeholder="Collection Barcode Printing"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="printer_name"
          title="Printer Name"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "SHOW" },
              { id: 0, value: "HIDE" },
            ]}
            value={values?.printer_name_show}
            onChange={(e) => setFieldValue("printer_name_show", e)}
            valueName="id"
            labelName="value"
            placeholder="Printer Name"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="varification_show"
          title="Varification Show"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "SHOW" },
              { id: 0, value: "HIDE" },
            ]}
            value={values?.varification_show}
            onChange={(e) => setFieldValue("varification_show", e)}
            valueName="id"
            labelName="value"
            placeholder="Verification"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="custom_invoice"
          title="Custom Invoice"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "SHOW" },
              { id: 0, value: "HIDE" },
            ]}
            value={values?.custom_invoice}
            onChange={(e) => setFieldValue("custom_invoice", e)}
            valueName="id"
            labelName="value"
            placeholder="Custom Invoice"
          />
        </div>
      </div>

      <div className="row mb-3">
        <InputLabel
          htmlFor="copyright"
          title="Copyright"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput type="text" name="copyright" placeholder="Copyright" />
        </div>
      </div>
      <div className="row">
        <label className="col-sm-3 col-form-label" />
        <div className="col-sm-9">
          {accessPerm(1, 2) && (
            <button type="submit" className="btn btn-primary px-5">
              Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsForm;
